export default class VideoYoutube {
    constructor () {
      this.$videoContainers = document.querySelectorAll('.fd-block-video-youtube')
      this.init()
    }
  
    init () {
      if (this.$videoContainers) {
        this.videoYoutube()
      }
    }
  
    videoYoutube() {
      console.log('youtube');
      if (document.querySelector('.fd-block-video-youtube .bloc-video')) {
          let btn_yt = document.querySelector('.fd-block-video-youtube .bloc-video .link a');
          btn_yt.addEventListener('click', (evt) => {
              console.log('url yt', evt.target);

              const yt_url = new URL(btn_yt.getAttribute('href'));
              const url_params = new URLSearchParams(yt_url.search);
              const yt_id = url_params.get('v');
              let div = document.createElement("div");
              div.setAttribute('id', 'yt-video');

              document.querySelector('.fd-block-video-youtube .bloc-video').prepend(div);
              var player;
              player = new YT.Player('yt-video', {
                  videoId: yt_id,
                  host: 'https://www.youtube-nocookie.com',
                  playerVars: {rel: 0, showinfo: 0, ecver: 2},
                  events: {
                      'onReady': onPlayerReady,
                      'onStateChange' : onPlayerStateChange,
                  }
              });

          function onPlayerReady(event)
          {
              event.target.playVideo();
          }

          function onPlayerStateChange(event)
          {
              if (event.data === 0) {
                  document.querySelector('.fd-block-video-youtube .bloc-video iframe').remove();
              }
          }
              evt.preventDefault();
          })
      }
    }
}
  
  